export function svgToPng(svgElement) {
  // Create a canvas element
  const canvas = document.createElement('canvas');
  canvas.width = svgElement.getAttribute('width');
  canvas.height = svgElement.getAttribute('height');

  // Get the SVG as a string
  const svgString = new XMLSerializer().serializeToString(svgElement);

  // Draw the SVG onto the canvas
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.onload = () => {
    ctx.drawImage(img, 0, 0);
    // Get the data URL of the resulting PNG image
    const dataUrl = canvas.toDataURL('image/png');
    return dataUrl;
  };
  return 'data:image/svg+xml;base64,' + btoa(svgString);
}
